"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_strings_1 = require("owa-strings");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
exports.DIVIDER_DISPLAY_NAME = '-';
function getComposeActionDisplayName(key) {
    switch (key) {
        case 'AddAttachment':
            return owa_mail_strings_1.default.attachTooltip;
        case 'AddInlineImage':
            return owa_mail_strings_1.default.insertPicturesInlineTooltip;
        case 'AddEmoji':
            return owa_mail_strings_1.default.emojiTooltip;
        case 'ToggleRibbon':
            return owa_mail_strings_1.default.formattingOptionsTooltip;
        case 'SaveDraft':
            return owa_mail_strings_1.default.saveDraft;
        case 'InsertSignature':
            return owa_mail_strings_1.default.insertSignature;
        case 'ShowFrom':
            return owa_mail_strings_1.default.showFrom;
        case 'SetImportance':
            return owa_mail_strings_1.default.setImportance;
        default:
            return '';
    }
}
exports.getComposeActionDisplayName = getComposeActionDisplayName;
function getReadActionDisplayName(key) {
    switch (key) {
        case 'Reply':
            return owa_mail_strings_1.default.itemHeaderReply;
        case 'ReplyAll':
            return owa_mail_strings_1.default.itemHeaderReplyAll;
        case 'Forward':
            return owa_mail_strings_1.default.itemHeaderForward;
        case 'Delete':
            return owa_mail_strings_1.default.itemHeaderDelete;
        case 'MarkReadUnread':
            return owa_mail_strings_1.default.markAsUnread;
        case 'FlagUnflag':
            return owa_mail_strings_1.default.itemHeaderFlag;
        case 'MarkJunkNotJunk':
            return owa_mail_strings_1.default.itemHeaderMarkAsJunk;
        case 'MarkAsPhishing':
            return owa_mail_strings_1.default.itemHeaderMarkAsPhishing;
        case 'Block':
            return owa_strings_1.format(owa_mail_strings_1.default.itemHeaderBlock, '');
        case 'CreateRule':
            return owa_mail_strings_1.default.createRule;
        case 'Print':
            return owa_mail_strings_1.default.itemHeaderPrint;
        case 'ShowInImmersiveReader':
            return owa_mail_strings_1.default.showInImmersiveReader;
        default:
            return '';
    }
}
exports.getReadActionDisplayName = getReadActionDisplayName;
//# sourceMappingURL=getDisplayNameFromKey.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/utils/getDisplayNameFromKey.js
// module id = 2797
// module chunks = 2 3 4